module.exports = __webpack_public_path__ + "static/media/normalization.8f94cc32.png";